import { Component, OnInit, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { WhatsappService } from '../whatsapp.service';
import { WhatsappSignUp } from 'src/app/models/whatsapp';
import { NotificationService } from 'src/app/shared/notification.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-wa-signup',
  templateUrl: './wa-signup.component.html',
  styleUrls: ['./wa-signup.component.less']
})
export class WaSignupComponent implements OnInit, OnDestroy {

  // *****************************************************************
  // SCRIPT WE NEED TO ADD TO THE HTML
  // *****************************************************************
  //   <script>
  //   window.fbAsyncInit = function() {
  //     FB.init({
  //       appId            : '520193753329286',
  //       autoLogAppEvents : true,
  //       xfbml            : true,
  //       version          : 'v22.0'
  //     });
  //   };
  // </script>
  // <script async defer crossorigin="anonymous"
  //   src="https://connect.facebook.net/en_US/sdk.js">
  // </script>
  //***********************************************************
  // Event Listener
  // ***********************************************************
  // window.addEventListener('message', (event) => {
  //   if (event.origin !== "https://www.facebook.com") return;
  //   try {
  //     const data = JSON.parse(event.data);
  //     if (data.type === 'WA_EMBEDDED_SIGNUP') {
  //       ...
  //     }
  //   } catch {
  //     ...
  //   }
  // });


  private readonly facebookAppId = '520193753329286'; 
  private readonly facebookSdkVersion = 'v22.0';      
  private readonly scriptId = 'facebook-jssdk';       // An ID for the script tag

  // Whatsapp Details
  private waPhoneNumberId: string = 'na';
  private waWabaId: string = 'na';
  private waBusinessId: string = 'na';

  public waSignupForm: FormGroup = new FormGroup({
    whatsappAccountName: new FormControl(''),
    whatsappCellNumber: new FormControl('')
  });

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private waService: WhatsappService,
    private notification: NotificationService
  ) {}

  ngOnInit(): void {
    // Ensure this runs only in the browser, not during server-side rendering (SSR) if used
    if (isPlatformBrowser(this.platformId)) {
      this.loadFacebookSdk();
      this.addFacebookMessageListener(); //Add lsitener for callback API to our window
    }
  }

  ngOnDestroy(): void {
    
    //The follwoing is the code for cleanin up the script, but I think it needs to remain, we first need to double check before removing it
    /* 
    if (isPlatformBrowser(this.platformId)) {
      const scriptElement = this.document.getElementById(this.scriptId);
      if (scriptElement) {
        scriptElement.remove();
        console.log('Removed Facebook SDK script tag.');
      }
      // delete (window as any).FB;
      // delete (window as any).fbAsyncInit;
    }
    */
    if (isPlatformBrowser(this.platformId)) {
      this.removeFacebookMessageListener();
    }
  }

  private loadFacebookSdk(): void {
    // Check if the SDK script tag already exists
    if (this.document.getElementById(this.scriptId)) {
      console.log('Facebook SDK script already exists.');
      return;
    }

    // Define the global fbAsyncInit function
    (window as any).fbAsyncInit = () => {
      console.log('fbAsyncInit called');
      (window as any).FB.init({
        appId: this.facebookAppId,
        autoLogAppEvents: true,
        xfbml: true,
        version: this.facebookSdkVersion
      });

    };

    // Create the script tag
    const script = this.document.createElement('script');
    script.id = this.scriptId;
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous'; 
    script.onerror = () => {
      console.error('Failed to load Facebook SDK script.');
    };


    // Append the script tag to the body
    console.log('Appending Facebook SDK script...');
    this.document.body.appendChild(script);
  }

  private addFacebookMessageListener(): void {
    console.log('Adding Facebook message listener.');
    window.addEventListener('message', this.handleFacebookMessage, false);
  }

  private removeFacebookMessageListener(): void {
    console.log('Removing Facebook message listener.');
    window.removeEventListener('message', this.handleFacebookMessage, false);
  }

  private handleFacebookMessage = (event: MessageEvent): void => {
    if (event.origin !== "https://www.facebook.com") {
      console.log('Ignoring message from origin:', event.origin); 
      return;
    }

    console.log('Received message from Facebook:', event.data);

    try {
      if (typeof event.data === 'string') {
        let data: any;
          try {            
            data = JSON.parse(event.data);
          } catch (error) {
            console.log('Error parsing JSON data from received facebook message:', error);
            console.log('Raw data from failed JSON parsing:', event.data);            
          }

          if (data && data.type && data.type === 'WA_EMBEDDED_SIGNUP') {
            console.log('Received WA_EMBEDDED_SIGNUP event:', data);
            this.waPhoneNumberId = data.data.phone_number_id;
            this.waWabaId = data.data.waba_id;
            this.waBusinessId = data.data.business_id;
            console.log('Extracted Details:', this.waPhoneNumberId, this.waWabaId, this.waBusinessId);
            

          } else {
            console.log('OTHER EVENT RECEIVED:', data);
          }
      } else {
         console.log('Received non-string message from Facebook:', event.data);
      }
    } catch (error) {      
      console.error('Could not parse message data from Facebook:', error, 'Raw data:', event.data);
    }
  }

  //login callback function
  private fbLoginCallback = (response: any): void => {
    console.log('Facebook Login Callback Response:', response);
    if (response && response.authResponse) {
      const code = response.authResponse.code;
      console.log('Received Facebook Login Code:', code);

      

      // ADD LOGINC HERE
      let signupData: WhatsappSignUp = new WhatsappSignUp();
      signupData.code = code;

      // Check to see if i can send the full response as string, otherwise just default it
      // Not ideal, but want to get to the FB API call
      try {

        signupData.fullResponse = JSON.stringify(response);
      }
      catch (error) {
        console.error('Error converting response to JSON:', error);
        signupData.fullResponse = 'Error converting response to JSON';
      }

      signupData.phoneNumberId = this.waPhoneNumberId;
      signupData.wabaId = this.waWabaId;
      signupData.businessId = this.waBusinessId;
      signupData.waBusinessName = this.waSignupForm.value.whatsappAccountName;
      signupData.waPhoneNumber = this.waSignupForm.value.whatsappCellNumber;
      console.log('Signup Data:', signupData);
      
      this.waService.sendWhatsappSignupRequest(signupData).subscribe({
        next: (res) => {
          this.notification.showInfo(res.message);
        },
        error: (err) => {
          console.error('Error during WhatsApp signup post to SF API:', err);
          this.notification.handleError(err);
        }

      })

    } 
    else {
      
      console.log('Facebook Login failed or was cancelled.', response ? response.status : 'No response');
      
    }
  }

  public triggerFbLogin(): void {
    // Double check again that we are not in SSR
    if (!isPlatformBrowser(this.platformId)) return; 
  
    // DEFAULT SETUP VAR: "business":{"id":null,"name":null,"email":null,"phone":{"code":null,"number":null},"website":null,"address":{"streetAddress1":null,"streetAddress2":null,"city":null,"state":null,"zipPostal":null,"country":null},"timezone":null},"phone":{"displayName":null,"category":null,"description":null},"preVerifiedPhone":{"ids":null},"solutionID":null,"whatsAppBusinessAccount":{"ids":null}

    const fb = (window as any).FB;
    if (fb) {
        fb.login(this.fbLoginCallback, { 
            config_id: '520849151087142',
            response_type: 'code',
            override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
            extras: {
              setup: {},
              featureType: '',
              sessionInfoVersion: '2',
            }
            
          
        });
    } else {
        console.error('Facebook SDK (FB object) not available to trigger login.');
        
    }
  }


}
